<aside class="block-schedule">
    <rwidget-schedule-route-trip [routeId]="routeId" [directionId]="directionId" [stopId]="stopId" [tripId]="tripId">
    </rwidget-schedule-route-trip>
</aside>
